import BigNumber from 'bignumber.js'
import { getCreatedByName } from 'helpers/AuditUserName'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React from 'react'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  mode?: string
}

export const ARScheduledBillingDetailContent = (props: DetailProps) => {
  const { listEl, listStatus, userList } = props

  const taxAmt = new BigNumber(listEl?.TaxScheme?.LatestTax?.Rate)
    .dividedBy(100)
    .multipliedBy(listEl?.BillingAmt)
    .toNumber()

  return (
    <>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Department
        </div>
        <div className="mdDesc"> {listEl?.CostCentre?.Name} </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Created Date
        </div>
        <div className="mdDesc">{formatDate(listEl?.createdTs)}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Created By
        </div>
        <div className="mdDesc">{getCreatedByName(listEl, userList)}</div>
      </div>

      {/* <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted Date'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {formatDate(listEl?.submittedTs)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted By'}
        </div>
        <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
          {userList?.find(user => user.ID == listEl?.submittedBy)?.name}
        </div>
      </div> */}

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Completed Date'}
            </div>
            <div className="mdDesc text-noflow">
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Completed By'}
            </div>
            <div className="mdDesc text-noflow">
              {getCreatedByName(listEl, userList) ??
                userList?.filter(user => user.ID == listEl?.approvedBy)[0]
                  ?.name}
            </div>
          </div>
        </>
      )}
    </>
  )
}
